module.exports = __webpack_public_path__ + "static/media/person-circle-outline 1.0bcd86ff.svg";